import { render, staticRenderFns } from "./ServicejobCreate.vue?vue&type=template&id=6b55e288&scoped=true"
import script from "./ServicejobCreate.vue?vue&type=script&lang=js"
export * from "./ServicejobCreate.vue?vue&type=script&lang=js"
import style0 from "./ServicejobCreate.vue?vue&type=style&index=0&id=6b55e288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b55e288",
  null
  
)

export default component.exports